import React, { Component, Context } from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import { IPSFacility, getFacilityLink, PSRole, getPSRole } from "../../../models/peer-support";
import { withAuth, IAuthProps } from "../../../laco-common/auth/AuthContext";
import { FacilityActionsProps, FacilityActions } from "./FacilityActions";
import { PhoneLinkWeb } from "../../ui/PhoneLinkWeb";
import { UIAddress } from "../../google-maps/Address";
import { UINoData } from "../../ui/UIComponents";
import { FacilityResources } from "./FacilityResources";
import ClientFirebase from "../../../laco-common/firebase/web";

type UIFacilitiesProps = {
	facilities: IPSFacility[];
	idToDelete?: string;
	renderList?: boolean;
	omitActions?: boolean;
	noDataMsg?: string;
} & Omit<FacilityActionsProps, "facility">;

class FacilitiesList extends Component<UIFacilitiesProps & IAuthProps> {
	static contextType: Context<ILayoutContext> = LayoutContext;

	renderActions(facility: IPSFacility, userRole: PSRole) {
		if (this.props.omitActions) return null;
		return (
			<FacilityActions
				facility={facility}
				onDeleteFacility={this.props.onDeleteFacility}
				onEditFacility={this.props.onEditFacility}
			/>
		);
	}

	renderList(userRole: PSRole) {
		return this.props.facilities.map((facility: IPSFacility, i: number) => {
			return (
				<div
					key={facility.id}
					className={clsx(
						"item-mobile-row alternate-row-style text-sm",
						// "animated faster slideInDown",
						i === 0 && "first-row",
						facility.id === this.props.idToDelete && "animated fadeOutUp z-index-minus-1"
					)}
				>
					<div className="d-flex flex-row justify-content-between">
						<h2 className={clsx("mb-2", "title-link")} style={{ fontSize: "1rem" }}>
							<NavLink to={getFacilityLink(facility)}>{facility.name}</NavLink>
						</h2>
						<div style={{ marginTop: "-5px", paddingLeft: "10px" }}>
							{this.renderActions(facility, userRole)}
						</div>
					</div>
					<PhoneLinkWeb className="mb-1" number={facility.phone} />
					<div className="mb-1">
						<UIAddress
							address={facility.address}
							showMapOnHover={true}
							showZipOnly={facility.showZipCodeOnly}
						/>
					</div>
					<FacilityResources facility={facility} className="horizontal-list mt-3" />
					<div className="clearfix" />
				</div>
			);
		});
	}

	render() {
		const userRole: PSRole = getPSRole(this.props.authContext, ClientFirebase);
		if (!this.props.facilities || !this.props.facilities.length)
			return <UINoData msg={this.props.noDataMsg || "No facilities"} />;
		return (
			<div className="facilities-list">
				{(this.props.renderList || !this.context.settings.isDesktopRes) && this.renderList(userRole)}
				{!this.props.renderList && this.context.settings.isDesktopRes && (
					<table className="table alternate-table text-sm">
						<thead>
							<tr>
								<th scope="col">Facility Name</th>
								<th scope="col">Resources</th>
								<th scope="col">Phone Number</th>
								<th scope="col" colSpan={2}>
									Address
								</th>
								<th scope="col">Actions</th>
							</tr>
						</thead>
						<tbody className="animated fadeInDown faster">
							{this.props.facilities.map((facility: IPSFacility, i: number) => {
								return (
									<tr
										key={facility.id}
										className={clsx(
											// "animated1 faster slideInDown",
											facility.id === this.props.idToDelete &&
												"animated fadeOutUp z-index-minus-1"
										)}
									>
										<td className="title-link">
											<NavLink to={getFacilityLink(facility)}>{facility.name}</NavLink>
										</td>
										<td>
											<FacilityResources facility={facility} />
										</td>
										<td>
											<PhoneLinkWeb number={facility.phone} />
										</td>
										<>
											<td colSpan={2}>
												<UIAddress
													address={facility.address}
													showMapOnHover={true}
													showZipOnly={facility.showZipCodeOnly}
												/>
											</td>
											<td className="actions-cell">{this.renderActions(facility, userRole)}</td>
										</>
									</tr>
								);
							})}
						</tbody>
					</table>
				)}
			</div>
		);
	}
}

export default withAuth(FacilitiesList);
